import React from 'react'
import styles from "styles/pages/Pages.module.scss";
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { RenderPosta } from './RenderPosta';
import { RenderPuesto } from './RenderPuesto';

export const RenderCap = (cap, allElements, elementIndex, getChildren, toggleExpand, expanded, calculateElementRows, calculateRowStart, hanndleSelectId, id) => {
        const postas = getChildren(cap.id, "posta");
        const directPuestos = getChildren(cap.id, "puesto");
        const isExpanded = expanded[cap.id];
        const hasChildren = postas.length > 0 || directPuestos.length > 0;

        const totalRows = calculateElementRows(cap);
        const capRowStart = calculateRowStart(allElements, elementIndex);

        let currentRow = capRowStart;
        const childrenWithRows = [];
        
        if (isExpanded) {
            postas.forEach(posta => {
                childrenWithRows.push({ type: 'posta', item: posta, row: currentRow });
                const puestos = getChildren(posta.id, "puesto");
                if (expanded[posta.id] && puestos.length > 0) {
                    currentRow += puestos.length;
                } else {
                    currentRow += 1;
                }
            });

            directPuestos.forEach(puesto => {
                childrenWithRows.push({ type: 'puesto', item: puesto, row: currentRow });
                currentRow += 1;
            });
        }

        return (
            <React.Fragment key={cap.id}>
                <div 
                    className={`${styles.containerSectionInfo} ${cap.id === id && styles.select} ${styles.capColor}`}
                    style={{ 
                        gridColumn: '4',
                        gridRow: `${capRowStart} / span ${totalRows}`
                    }}
                    onClick={() => hanndleSelectId(cap.id)}
                >
                    <div className={styles.sectionText}>
                        {hasChildren && (
                            <div onClick={(e) => toggleExpand(cap.id, e)}>
                                {isExpanded ? 
                                    <ChevronRightRoundedIcon size={20} /> : 
                                    <ChevronLeftRoundedIcon size={20} />
                                }
                            </div>
                        )}
                        <span className={styles.sectionName}>{cap.name}</span>
                    </div>
                </div>
                
                {isExpanded && hasChildren && (
                    <>
                        {childrenWithRows.map(child => {
                            if (child.type === 'posta') {
                                return RenderPosta(child.item, child.row, getChildren, hanndleSelectId, toggleExpand, expanded, id);
                            } else {
                                return RenderPuesto(child.item, child.row, hanndleSelectId, id);
                            }
                        })}
                    </>
                )}
            </React.Fragment>
        );
    };
